import Vue from 'vue';

const CREATE_CATEGORY_URL = '/category/';
const UPDATE_CATEGORY_URL = '/category/';
const UPDATE_CATEGORY_ORDER_URL = '/category/category-order';
const UPDATE_CATEGORY_PRODUCT_ORDER_URL = '/category/product-order';
const ADD_PRODUCT_URL = '/category/add-product';
const REMOVE_PRODUCT_URL = '/category/remove-product';
const GET_CATEGORIES_URL = '/category/list';
const GET_PRODUCTS_URL = '/category/products';
const DELETE_CATEGORY_URL = '/category/';
const GET_CATEGORY_PRODUCT_LIST_URL = '/category/product-list';

class CategoryService {

    async create(data) {
        return await Vue.prototype.$axios.post(CREATE_CATEGORY_URL, data);
    }

    async update(data) {
        return await Vue.prototype.$axios.put(UPDATE_CATEGORY_URL, data);
    }

    async updateCategoryOrder(data) {
        return await Vue.prototype.$axios.post(UPDATE_CATEGORY_ORDER_URL, data);
    }

    async updateCategoryProductOrder(data) {
        return await Vue.prototype.$axios.post(UPDATE_CATEGORY_PRODUCT_ORDER_URL, data);
    }

    async addProduct(data) {
        return await Vue.prototype.$axios.post(ADD_PRODUCT_URL, data);
    }

    async removeProduct(data) {
        return await Vue.prototype.$axios.post(REMOVE_PRODUCT_URL, data);
    }

    async getCategories() {
        return await Vue.prototype.$axios.get(GET_CATEGORIES_URL);
    }

    async getProductsByCategoryId(id) {
        return await Vue.prototype.$axios.get(GET_PRODUCTS_URL, {params: {id: id}});
    }

    async delete(id) {
        return await Vue.prototype.$axios.delete(DELETE_CATEGORY_URL, {params: {id: id}});
    }

    async getCategoryProductList(data) {
        return await Vue.prototype.$axios.post(GET_CATEGORY_PRODUCT_LIST_URL, data);
    }
}

export default new CategoryService();
